import type { PropsWithChildren } from 'react'

import React, { useState } from 'react'

import { useStoreContext } from '../../../../../contexts/StoreContext'
import useWindowDimensions from '../../../../../hooks/useWindowDimensions'
import { getMobileOS } from '../../../../../utils/getMobileOS'

import './notifications-bar.scss'
import { validatePlatform } from '../../../../../utils/validatePlatform'
import { Image } from '../../../../ui/Image'
import EngagementModal from '../../../EngagementModal'

interface NotificationsBarWrapperProps {
  href: string
  handleOpenModal: () => void
  isMobile: boolean | null
}

function NotificationsBarWrapper({
  children,
  href,
  handleOpenModal,
  isMobile,
}: PropsWithChildren<NotificationsBarWrapperProps>) {
  if (isMobile)
    return (
      <a
        href={href}
        target="_blank"
        aria-label="Baixar aplicativo"
        className="top-bar-link"
        id="top-bar-app-download"
        rel="noreferrer"
      >
        {children}
      </a>
    )

  return (
    <button className="top-bar-button-container" onClick={handleOpenModal}>
      {children}
    </button>
  )
}

function NotificationsBar() {
  const { notificationsBar, loyaltyClubDownloadImages } = useStoreContext()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { isMobile } = useWindowDimensions()

  const showComponent = validatePlatform({
    isMobile,
    platforms: notificationsBar?.platforms,
  })

  if (!notificationsBar || !showComponent) return <></>

  const { backgroundColor, labelColor, description, leftIcon, rightIcon } =
    notificationsBar

  const OS = getMobileOS()

  const href =
    OS === 'iOS'
      ? loyaltyClubDownloadImages?.iOSAppLink
      : loyaltyClubDownloadImages?.androidAppLink

  return (
    <>
      <NotificationsBarWrapper
        href={href ?? ''}
        handleOpenModal={() => setIsModalOpen(true)}
        isMobile={isMobile}
      >
        <div style={{ backgroundColor }} className="top-bar-container">
          <Image
            alt="logo icon"
            baseUrl={leftIcon}
            width={32}
            height={32}
            className="top-bar-icon-image"
          />

          <span style={{ color: labelColor }}>{description}</span>
          <div className="top-bar-button">
            <Image
              baseUrl={rightIcon}
              alt="download button"
              width={78}
              height={30}
            />
          </div>
        </div>
      </NotificationsBarWrapper>

      <EngagementModal
        isModalOpen={isModalOpen}
        handleCloseModal={() => setIsModalOpen(false)}
      />
    </>
  )
}

export default NotificationsBar
